<script setup>

import {mdiBarcodeScan} from "@mdi/js";
import {ref} from "vue";
import BarcodeScannerModal from "../../utils/BarcodeScannerModal.vue";
import QrScanButton from "../QrScanButton.vue";


const temporaryIdentifier = defineModel('temporaryIdentifier');
const admittedToHospitalTimestamp = defineModel('admittedToHospitalTimestamp');
const destinationWard = defineModel('destinationWard');

const props = defineProps({
  formProps: {
    type: Object,
    required: true,
  },
  validateField: {
    type: Function,
    required: true,
  },
});
const emit = defineEmits(['submit']);

const showBarcodeModal = ref(false);

async function submit() {
  let allValid = true;
  for (const field of Object.keys(props.formProps)) {
    const {valid} = await props.validateField(field);
    allValid = allValid && valid;
  }

  if (!allValid) {
    return;
  }

  emit('submit', {});
}

function updateTemporaryIdentifier(value) {
  temporaryIdentifier.value = value;
}

</script>

<template>
  <main>
    <h1>{{ pgettext('label', 'Hospital Records') }}</h1>

    <div>
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field v-model="temporaryIdentifier"
                            v-bind="formProps.temporaryIdentifier"
                            :label="pgettext('label', 'Temporary Identifier')">
                <template #prepend>
                  <v-btn @click="showBarcodeModal = true" size="small" :prepend-icon="mdiBarcodeScan">
                    {{ pgettext('action', 'Scan barcode') }}
                  </v-btn>
                </template>
              </v-text-field>

              <v-text-field v-model="admittedToHospitalTimestamp"
                            :label="pgettext('label', 'Admitted to Hospital Timestamp')"
                            type="datetime-local"
                            v-bind="formProps.admittedToHospitalTimestamp"/>

              <v-text-field v-model="destinationWard"
                            v-bind="formProps.destinationWard"
                            :label="pgettext('label', 'Destination Ward')"/>

            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <p class="text-center mt-6">
        <v-btn size="large" block @click="submit()">
          <strong>{{ pgettext('action', 'Continue') }}</strong>
        </v-btn>
      </p>
    </div>
    <BarcodeScannerModal v-if="showBarcodeModal" @close="showBarcodeModal = false"
                         @commitValue="updateTemporaryIdentifier"/>
  </main>

</template>
